module.exports = __webpack_public_path__ + "img/eag_logo.387bbfe4.png";